// dodatkowe informacje dla koszyka - wyświetlane w sidebarze

import React, { FC } from 'react';

import { useGetCartAdditionalInformation } from 'api';
import { Alert } from 'components/controls';

import styles from 'theme/components/containers/CartAdditionalInformation/CartAdditionalInformation.module.scss';

type TAlertType = 'error' | 'warning' | 'success' | 'info';

const ALERT_TYPES: TAlertType[] = ['error', 'warning', 'success', 'info'];

const toAlertType = (style: string): TAlertType =>
  ALERT_TYPES.includes(style as TAlertType) ? (style as TAlertType) : 'info';

interface IProps {
  cartId: number;
}

const CartAdditionalInformation: FC<IProps> = ({ cartId }) => {
  const { data: additionalInformationData } = useGetCartAdditionalInformation(cartId);

  if (!additionalInformationData?.items?.length) {
    return null;
  }

  return (
    <div className="StylePath-Components-Containers-CartAdditionalInformation">
      {additionalInformationData.items.map((additionalInformation, i) => (
        <div className={styles.additionalInformationDataWrapper} key={i}>
          <Alert type={toAlertType(additionalInformation.style)}>
            <div
              dangerouslySetInnerHTML={{ __html: additionalInformation.message_html || '' }}
            />
          </Alert>
        </div>
      ))}
    </div>
  );
};

export default CartAdditionalInformation;
